import { render, staticRenderFns } from "./CurrentPlanCosts.vue?vue&type=template&id=1a420d1b&lang=pug"
import script from "./CurrentPlanCosts.vue?vue&type=script&lang=js"
export * from "./CurrentPlanCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardAepCopayBlock: require('/home/docker/code/frontend/components/card/AepCopayBlock.vue').default,CardAepNetworkBlock: require('/home/docker/code/frontend/components/card/AepNetworkBlock.vue').default})
